import * as React from 'react';
import {FormControl, Slider, FormHelperText, Box, Typography} from '@mui/material';

const Range = (props: any) => {
    let { onChange, label, description, required, value, error, minimum, maximum, step, enabled, visible,
    prefix, suffix} = props;

    const errString = required ? "should be number" : "should be number,null";
    error = (error === errString) ? '' : error;

    let showDescription = description !== undefined && description !== "";
    if(minimum !== undefined && maximum !== undefined && value !== "" && (value < minimum || value > maximum)){
        error = `Number should not be less than ${minimum} and more than ${maximum}`;
    }
    let showError = error !== undefined && error !== "" && value !== "" ;
    label = required ? label+" *" : label;

    suffix = (suffix === "" ? "" : " ") + suffix;
    let minimumLabel = prefix + minimum + suffix;
    let maximumLabel = prefix + maximum + suffix;
    let valueLabel = (value !== null ? prefix: "") + value !== null ? value : "" + (value !== null ? suffix: "");
    const marks = [
        {
            value: minimum,
            label: minimumLabel
        },
        {
            value: maximum,
            label: maximumLabel
        }
    ];

    return (
        <Box sx={{ display: visible ? 'block' : 'none' }}>
            <FormControl className="form-control" fullWidth={true}>
                <Typography color="secondary" className="form-separate-label">
                    {label}: {valueLabel}
                </Typography>
                <Slider
                    value={value}
                    min={minimum}
                    max={maximum}
                    step={step}
                    onChange={onChange}
                    valueLabelDisplay="auto"
                    aria-labelledby="non-linear-slider"
                    marks={marks}
                    disabled={!enabled}
                />
                <FormHelperText>
                    {showDescription ? description : null}
                </FormHelperText>
                <FormHelperText error={showError}>
                    {showError ? error : null}
                </FormHelperText>
            </FormControl>
        </Box>
    );
}

export default Range;
